<div class="center-item position-relative" [ngClass]="{'link': !disabled}" (click)='onClick()'>
    <img *ngIf='icon' [src]="icon">
    <a class="button shadow-box" [ngClass]="{'disabled': disabled, 'icon': icon}">
        <ng-content></ng-content>
    </a>
</div>